export const ServiceId = "service_2buhgzr"
export const TemplateId = "template_k7nhtar"
export const ParamsId = "dv-Ww8QtCJA8FJ_OC"
